import { render } from "./TicketClosedTable.vue?vue&type=template&id=07793f3d&scoped=true"
import script from "./TicketClosedTable.vue?vue&type=script&lang=js"
export * from "./TicketClosedTable.vue?vue&type=script&lang=js"

import "./TicketClosedTable.vue?vue&type=style&index=0&id=07793f3d&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07793f3d"]])

export default __exports__